<template>
  <div>
    <div
      class="portrait position-relative"
      :style="'background-image: url(' + sponsor.image + ');'"
      v-if="sponsor && sponsor.title !== null"
    >
      <a :href="sponsor.url" target="_blank" class="clickable-area"></a>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sponsors: {},
      sponsor: null,
    };
  },

  props: ["url", "preferredSponsor"],

  computed: {},

  created() {},

  mounted() {
    if (this.preferredSponsor) {
      this.getSponsor();
    } else {
      this.getSponsors();
    }
  },

  watch: {},

  methods: {
    getSponsors() {
      axios
        .get(this.url, {
          params: {},
        })
        .then((response) => {
          this.sponsors = response.data.data;
          this.randomNumber();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSponsor() {
      var url = this.url + "/" + this.preferredSponsor;
      axios
        .get(url, {
          params: {},
        })
        .then((response) => {
          this.sponsor = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    randomNumber() {
      var number = Math.floor(Math.random() * 1000);
      var index = number % this.sponsors.length;

      this.sponsor = this.sponsors[index];
    },
  },
};
</script>
